import React, { useState,  useEffect } from "react";
import { Button } from "@progress/kendo-react-buttons";
import "../Card/card-style.css";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import {  CusFormInput3 } from "../validation/Form-Components";
import { nricValidator, refNoValidator, uenValidator } from "../validation/Validators";
import service from '../services/ApiService';
import ReCAPTCHA from 'react-google-recaptcha';
import { useHistory } from "react-router-dom";
import config from '../appconfig/config.json';
import storage from '../factory/StorageFactory.js';
import CusToast from '../components/CusToast';
import resumeperson from '../images/sme-banner1.png';
import { CardImage } from '@progress/kendo-react-layout';
import Loading from "../components/Loading";
import optService from '../services/OtpApiService';
import useCountDown from "react-countdown-hook";
import helper from '../factory/Helper';

let count3TimeExpired = 0;
let count3TimeToExist = 0;
// let userMobileNo = '';

const Consent = (props) => {

  let timer;
  const history = useHistory();

  const [isError,setIsError] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [isloading, setIsLoading] = useState(false);
  const [resData, setResData] = useState();
  const [params,setParams] = useState();
  const [captchaResult, setCaptchaResult] = useState(false); //Google recaptcha value

  const [initFormData,setInitFormData] = useState({
    RefNo:'',
    NRIC:'',
    UENumber:''
  });

  const [otpAuthToken,setOtpAuthToken] = useState();
  const [userMobileNo,setUserMobileNo] = useState();
  const [isOtpGeneratedSuccess,setIsOtpGeneratedSuccess] = useState(false);
  const [OTPValue, setOTPValue] = useState("");
  const initialTime = 120 * 1000; // initial time in milliseconds, defaults to 60000
  const interval = 1000; // interval to change remaining time amount, defaults to 1000
  const [timeLeft, { start, pause, resume, reset }] = useCountDown( initialTime, interval );
  const [showOTPBar,setShowOTPBar] = useState(false);
  const [currentTime, setCurrentTime] = useState();
  const [showOTPResendRequestErr, setShowOTPResendRequestErr] = useState(false);

  useEffect(() => {
 
    window.scrollTo(0,0);
    postSecurity();
    getQueryString();
    count3TimeToExist= 0;
    count3TimeExpired = 0;
    // userMobileNo = '';
    getTodayDate();
    getCurrentTime();

    return () => clearTimeout(timer);
 }, []);

 const getQueryString =()=>{
 
    const queryString = require('query-string');
    const parsed = queryString.parse(props.location.search);
  
    if(parsed.referenceno) {
      setInitFormData({
        RefNo:parsed.referenceno,
        NRIC:'',
        UENumber:''
      })
    }

    // if(parsed.value) {
    //  storage.setIsFirstTime(parsed.value);
    // }

    if(parsed.referenceno) {
      storage.setRefNo(parsed.referenceno);
    }
 }

 
 const postSecurity =()=>{
  setIsLoading(true);
  service.security().then(res =>{

      let resData = res.data;
      if(resData){
        storage.setToken(resData.token);
        storage.setTokenExpiry(resData.tokenExpirationDate);
      }

      if(config.EnableOTP) {
        getOTPSecurityToken();  
      } 
      else {
        setIsLoading(false);
      }          
  })
  .catch(err => {
      showErrMsg('Service is not available.')
      setIsLoading(false);
  });
}

  const handleSubmit = (dataItem) => {

    if(config.ReCaptcha.enable && !captchaResult) {
      showErrMsg("Please do not leave field blank");
      return;
    }
    
    if(dataItem.isValid) {
      let data = JSON.parse(JSON.stringify(dataItem.values));
      saveVerificationForm(formatJsonParams(data))
    }
  }

  const handleOTPSubmit = (e) => {
    e.preventDefault();
    if(OTPValue.length === 6) {
        if(config.EnableOTP){
            if(timeLeft === 0) {  //check generated OTP expired time
                count3TimeExpired = count3TimeExpired+1;
                setOTPValue('');
                showErrMsg('The OTP entered has expired. Please re-enter the 6 Digit OTP.')
                return;
            }

            count3TimeToExist = count3TimeToExist + 1;
            verifyOTPDetails();
        }
        else {
          goNext(resData.model.product,resData.model.name,resData.model.isFirstUser,resData.model.isContinue,params.nric);
        }
    }
}
  
  const saveVerificationForm = (params) => {
    setIsLoading(true);
    service.verificationForm(params).then(res=>{
      setIsLoading(false);
      let resData = res.data;
      if(resData.isSucess){
          if(resData.model.stateid === "" || resData.model.stateid === null|| resData.model.stateid === undefined ) {
            if(resData.model.product.toUpperCase()  === 'SUBMITTED'){
              showErrMsg('We are sorry. There are no records to resume application.');
            }
            else if(resData.model.product.toUpperCase()  === 'EXPIRED') {
              history.push(config.route.InvalidApplication);
            }
            else {
              showErrMsg('Invalid Input. Please try again.');
            }
          }
          else {
            if(resData.model.isFirstUser === null || resData.model.isContinue === null) {
              showErrMsg('Invalid data.');
              return;
            }
            //success
            setParams(params);
            setUserMobileNo(resData.model.mobileNo);
            setShowOTPBar(true);
            setResData(resData);
            storage.setStateId(resData.model.stateid);
            storage.setRefNo(params.ReferenceNo);
            // goNext(resData.model.product,resData.model.name,resData.model.isFirstUser,resData.model.isContinue,params.nric);
          }
      }  
      else {
        showErrMsg(resData.errorMessage);
      }         
    })
    .catch(err => {
     
      setIsLoading(false);
      showErrMsg(config.error.GetApiFailed);
    });
  }

  const goNext = (productType,name,isFirstUser,isContinue,ic) => {
    if(productType && name){
      // console.log('productType: ',productType + ' name: '+name);
      history.push(config.route.Home+'?option='+productType,{from: config.route.Consent,n:name,isFU:isFirstUser,isCont:isContinue,ic:ic});
    }
    else {
      // console.log('no prod type and name');
      history.push(config.route.Home,{from: config.route.Consent});
    }
  }

  let formatJsonParams = function(data) {
    let params = {
      ReferenceNo:data.RefNo.trim(),
      nric:data.NRIC.trim(),
      uen: data.UENumber.trim(),
      Email: '',
      Mobile:''
    }
    return params;
  }
  
  const showErrMsg = (msg) => {
    setIsError(true);
    setErrMsg(msg);
    setErrMsgTimeout();
  }

  const setErrMsgTimeout= () => {
    timer = setTimeout(() => {
      setIsError(false);
    }, config.error.msgTimeout);
  }

  const handleRequestOTP = (e) => {
    e.preventDefault();
   
    if(config.EnableOTP) {
      generateOTP(otpAuthToken,userMobileNo);
    }
    else {
      setIsOtpGeneratedSuccess(true);
    }
  }

const handleResendOTP = (e) => {
  e.preventDefault();
  if(timeLeft === 0) {
      setShowOTPResendRequestErr(false);
      const newTime = 120 * 1000;
      start(newTime);
      generateOTP(otpAuthToken,userMobileNo);
  }
  else {
      setShowOTPResendRequestErr(true);
  }
}

const getOTPSecurityToken =()=>{
 
  optService.OTPSecurity().then(res => {
      setIsLoading(false);
      let resData = res.data;
      if(resData){
        setOtpAuthToken(resData.token);
      }           
  })
  .catch(err => {
      console.log('@getOTPSecurityToken: ',err);
      setIsLoading(false);
  });
}

  const generateOTP = (authToken, mobileNo) => {
    setIsLoading(true);
    let mobileNum = mobileNo; //response.MobileNonsm
    let accessId = "5911";
    let countryCode = "00065";
    let legalID = "T0499906H";
    optService.OTPGeneration(mobileNum, accessId, countryCode, legalID,authToken)
        .then(async (res) => {
          setIsLoading(false);
            const data = res.data;
            if (!data.didError) {
                let res = data.model.msg;
                let resMsgBdy = res.msgBody;
                let resMsgHdr = res.msgHdr;
                if (resMsgHdr.statusDesc === "Success") {
                    start();
                    setIsOtpGeneratedSuccess(true);
                }
                else {
                    showErrMsg('Unable to generate OTP. Please try again.')
                    setIsOtpGeneratedSuccess(false);
                }
            }
        })
        .catch((err) => {
            console.log(err);
            showErrMsg('Unable to generate OTP. Please try again.')
            setIsLoading(false);
            setIsOtpGeneratedSuccess(false);
        });
      }

      const verifyOTPDetails = async () => {
        
        if (OTPValue) {
            setIsLoading(true);
          // let req = setAllOTPResponces;
          let mobileNum = userMobileNo; //response.MobileNonsm
          let accessId = "5911";
          let countryCode = "00065";
          let legalID = "T0499906H";
          let OTP = OTPValue;
  
          optService
            .OTPVerification(mobileNum, OTP, accessId, countryCode, legalID,otpAuthToken)
            .then(async (res) => {
                setIsLoading(false);
              const data = res.data;
              if (!data.didError) {
                let res = data.model.msg;
                let resMsgBdy = res.msgBody;
                let resMsgHdr = res.msgHdr;
             
                if (resMsgHdr.statusCode === "0") {
                  goNext(resData.model.product,resData.model.name,resData.model.isFirstUser,resData.model.isContinue,params.nric);
                } else {
                    showOTPErrMsg();
                }
              }
            })
            .catch((err) => {
                console.log('@verifyOTPDetails: ',err);
                setIsLoading(false);
                setShowOTPBar(false);
                showErrMsg("Unable to verify OTP. Please try again.");
                count3TimeToExist = 0;
            });
    
        } else {
 
          showErrMsg("Please enter valid numeric 6 digit OTP");
        }
      };
      
    const showOTPErrMsg = () => {
      if (count3TimeToExist <= 3) {
          setOTPValue('');
          if(count3TimeToExist === 1) {
              showErrMsg("1/3 incorrect OTP")
          }
          else if(count3TimeToExist === 2) {
              showErrMsg("2/3 incorrect OTP")
          }
          else if(count3TimeToExist === 3) {
              showErrMsg("3/3 incorrect OTP. Your application is unsuccessful due to maximum number of OTP attempts. Do reapply.")
          }
      } else {
          gotoInvalidOTP()
          return;
      }
  }

  const gotoInvalidOTP = () => {
    if(resData.model.isFirstUser === 'true') {
        history.push(config.route.InvalidOTP,{from: config.route.Consent,isFU:true});
    }
    else {
        history.push(config.route.InvalidOTP,{from: config.route.Consent,isFU:false});
    }
}

    const isNumber = async (evt) => { // allow number
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
    
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          await setOTPValue("");
 
          return false;
        } else {
 
          return true;
        }
    };

  const handleOTPInput =  async (e) => {  // get and set OTP number 
      const re = /^[0-9\b]+$/;
      if (e.target.value === "" || re.test(e.target.value)) {
        await setOTPValue(e.target.value);
      }

      if (e.target.value.length === 6) {
 
      } else {
     
      }
  };

  const disableSubmitOTPBtn = () => {
    let disableBtn = false;
    if(!OTPValue){
        disableBtn = true;
    }
    else if(OTPValue.length !== 6) {
        disableBtn = true;
    }

    return disableBtn;
}
 

const otpDisplayMsg = () => {
  let msg = '';
  if(showOTPResendRequestErr) {
      msg = 'You have already submitted an OTP request earlier. To avoid multiple requests, please wait a few minutes for your OTP to be sent to you before making another request.' 
  }
  else {
      msg = 'OTP has been sent to '+helper.mask(userMobileNo,4)+' ('+getTodayDate()+' '+currentTime+'). If you did not receive,';
  }
 
  return msg;
}

const getTodayDate = () => {
  const  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  let today = new Date();
  let dd =  String(today.getDate()).padStart(2, '0');
  let mm =  months[today.getMonth()];
  let yyyy = today.getFullYear();
  today = dd + ' ' + mm + ' '+yyyy;
  return today;
}


const getCurrentTime = () => {
  const today = new Date();
  let h = today.getHours();
  let m = today.getMinutes();
  let s = today.getSeconds();
  m = checkTime(m);
  s = checkTime(s);
  setCurrentTime(h+':'+m+':'+s);
  setTimeout(getCurrentTime,1000);
}


function checkTime(i) {
  if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
  return i;
}

function onChangeRecapthcha(value) {
  // alert("sucess");

  // fetch('http://127.0.0.1:8000/recaptcha/', {
  //   method: 'POST',
  //   body: JSON.stringify({ 'captcha_value': value }),
  //   headers: { 'Content-Type': 'application/json' }
  // })
  //  .then(res => res.json())
  //  .then(data => {
  //    alert(data)
  //    console.log(data.captcha.success)
  //    //setCaptchaResult(data.captcha.success)
  //  }) 
  // console.log("Captcha value:", value);
  let cValue = value;

  if(cValue) {
    setCaptchaResult(true);
  }
  else {
   setCaptchaResult(false);
  }
}

const onRecaptchaErrored = ( ) => {
  console.log('@onRecaptchaErrored');
  showErrMsg(config.error.ReCaptchaFailed);
}

const onAsyncScriptOnLoad = (data) => {
  console.log('@onAsyncScriptOnLoad')
}

const onRecaptchaExpired = () => {
  console.log('@onRecaptchaExpired');
  setCaptchaResult(false);
}

const toHHMMSS = (val) => {
  var sec_num = parseInt(val / 1000, 10); 
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
      hours = "0" + hours;
  }
  if (minutes < 10) {
       minutes = "0" + minutes;
  }
  if (seconds < 10) {
      seconds = "0" + seconds;
  }
  return minutes + ":" + seconds;
}


  return (
    <div className="container-fluid">
    <br></br>
    <p className="welcome mb-0 k-align-items-center">
      {'Business Account Opening'}<br/>
      {'SME Banking'}
    </p>
    <div className="demo-section k-content dynmicwhitecntr DynamicFields">
      <div className="cardbd">
          <CardImage className="hdImg" alt="bImag1" src={resumeperson}  />
           <div>
           <Form
              onSubmitClick={handleSubmit}
              initialValues={initFormData}
              key={JSON.stringify(initFormData)}
              render={(formRenderProps) => (
              <FormElement>
              <div className="row cRow3">
                <div className="col-12" style={{ textAlign: "left" }}>
                    <p className="welcomeblack mb-0 k-align-items-center">
                      {'Welcome back!'}
                    </p>
                    <p style={{
                      textAlign: "center",
                      fontWeight: "500",
                      letterSpacing: 0,
                      color: "#585858",
                      opacity: "1",
                      fontSize: "1em"
                      }} className="k-align-items-center">
                        {'Resume your application'}
                    </p>
                    <br />

                    <Field component={CusFormInput3} leftLabelId={"lbRefNo"} 
                      leftLabelName={"Reference No."}
                      id={"RefNo"}
                      name={"RefNo"}
                      placeholder={"eg. RSME Account-1234567890-PS"}
                      disabled={showOTPBar}
                      validator={refNoValidator} />
                    <br />
                    <Field
                      component={CusFormInput3}
                      leftLabelId={"lbUENNo"}
                      leftLabelName={"Your Business Unique Entity Number (UEN)"}
                      id={"UENumber"}
                      name={"UENumber"}
                      placeholder={"eg. 1234567890M"}
                      disabled={showOTPBar}
                      validator={uenValidator} />
                    <br/>

                    <Field
                      component={CusFormInput3}
                      leftLabelId={"lbNRIC"}
                      leftLabelName={"Your NRIC/FIN"}
                      id={"NRIC"}
                      name={"NRIC"}
                      placeholder={"eg. S9123456M"}
                      disabled={showOTPBar}
                      validator={nricValidator} />
                    <br />

                    {/* <Field
                      component={CusFormInput}
                      leftLabelId={"lbEmail"}
                      leftLabelName={"Email Address*"}
                      id={"Email"}
                      name={"Email"}
                      placeholder={"Email Address"}
                      width={"9"}
                      maxLength={60}
                      validator={emailValidator} />
                    <br />
                    <Field
                      component={CusFormInput}
                      leftLabelId={"lbMobile"}
                      leftLabelName={"Mobile Number*"}
                      id={"Mobile"}
                      name={"Mobile"}
                      placeholder={"Mobile Number"}
                      maxLength={8}
                      validator={mobileNoValidator}
                      width={"9"} /> */}

                      {config.ReCaptcha.enable &&
                      <div className="k-align-items-center recaptcha-box">
                        <ReCAPTCHA
                          className="g-recaptcha"
                          sitekey={config.ReCaptcha.sitekey}
                          onChange={onChangeRecapthcha}
                          onErrored={onRecaptchaErrored}
                          asyncScriptOnLoad={onAsyncScriptOnLoad}
                          onExpired={onRecaptchaExpired} /> 
                      </div>
                    }
                    <div className="row" style={{ paddingTop: "1rem" }}>
                        <div className="col-12 text-center">
                          <Button type={'submit'} primary={true} className="btPce greenbtn2 sccbTxt" disabled={!formRenderProps.valid} >
                            SUBMIT
                          </Button>
                          <br />
                          <br />
                        </div>
                    </div>
                </div>
              </div>
              {showOTPBar &&
              <div>
              {isOtpGeneratedSuccess?
                <div className="row around-xs elementVisible yellow-bottom-bar">
                  <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                  {showOTPResendRequestErr? 
                    <div className="box otp-sent-txt">
                      <span className="k-icon k-i-warning" style={{paddingLeft:'10px', fontSize:'24px'}} />&nbsp; 
                      OTP request unsuccessful
                    </div>
                    :
                    <div className="box otp-sent-txt">
                      <span className="k-icon k-i-check-outline" style={{paddingLeft:'10px', fontSize:'24px'}} />&nbsp; 
                      OTP has been sent 
                    </div>
                    }
                  </div>
                  <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                    <div className="box row">
                      <div className="otp-timer-txt">
                        {showOTPResendRequestErr?
                          <div style={{padding:'5px'}}>
                            {otpDisplayMsg()}
                            <br/>
                            <span style={{fontWeight:'bold'}} onClick={handleResendOTP}> 
                              {timeLeft === 0?
                                "Resend OTP"
                                :
                                "Resend in "+toHHMMSS(timeLeft)
                              }
                            </span>
                          </div>
                          :
                          <div style={{padding:'5px'}}>
                            {otpDisplayMsg()}
                            <span style={{fontWeight:'bold'}} onClick={handleResendOTP}>&nbsp;click here</span>
                          </div>
                          }
                      </div>
                      </div>
                  </div>
                  <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                    <div className="box row">
                      <span className="k-icon k-i-clock otp-click-icon"  />
                      <div className="otp-timer-input">
                        <input className="k-textbox" style={{ width: "100%" }} type="password" pattern="[0-9]+" maxLength="6" minLength="6" value={OTPValue}
                          onKeyPress={isNumber} placeholder="SMS OTP" name="" id="OTPValue" disabled={!isOtpGeneratedSuccess} onChange={handleOTPInput} />
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <div className="box row">
                      <div className="otp-btn">
                        <button className="k-button btn btn-success" disabled={disableSubmitOTPBtn()} onClick={handleOTPSubmit}>{'SUBMIT'}</button>
                      </div>
                    </div>
                  </div>
                </div>
                :
                <div className="row around-xs elementVisible yellow-bottom-bar">
                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                  <div className="box"></div>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <div className="box row" >
                    <div className="otp-info-txt" style={{padding:'5px'}}>SMS OTP: Get the 6-digit OTP via SMS to authorize your transaction.</div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                  <div className="box row">
                    <div className="otp-input">
                      <input className="k-textbox" style={{ width: "100%" }} type="password" pattern="[0-9]+" maxLength="6" minLength="6" value={OTPValue}
                        onKeyPress={isNumber} placeholder="SMS OTP" name="" id="OTPValue" disabled={!isOtpGeneratedSuccess} onChange={handleOTPInput} />
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <div className="box row">
                      <div className="otp-btn" >
                        <button className="btn btn-success" onClick={handleRequestOTP}>{'REQUEST'}</button>
                      </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                  <div className="box"></div>
                </div>
              </div> 
              }
              </div>
              }      
              <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
              {isloading && <Loading />}
            </FormElement>
          )}></Form>
        </div>
     </div>
    </div>
  </div>
  );
};

export default Consent;
